import template from './report_results_view.html';

class ReportResultsViewModel
{
	constructor (params, element)
	{
		this.params = params;
		this.element = element;
		
		this.report_id = ko_helper.safe_observable(params.report_id || '');
		
		this.report_created_date = ko.observable();
		this.report_status_message = ko.observable();
		this.is_error = ko.observable(false);
		this.schema_name = ko.observable('reports_data');
		this.table_name = ko.observable();
		this.table_data = ko.observable();
		this.record_total = ko.observable();
		
		this.report_id.subscribe(function() {this.get_report_results()},this);
		//this.version.subscribe(function() {this.get_report_results()},this)
		//this.report_definition_version.subscribe( () => this.get_report_results());
	}

	async get_report_results(report_id)
	{
		this.table_data();
		this.record_total();
		//Get report info
		let data = await Grape.fetches.getJSON('/api/report', { 'report_id': this.report_id()});
		if (data) {
			if (data.metadata) {
				this.report_data = data.metadata;
				this.report_created_date(data.metadata.date_inserted);
			}

			if (data.status === 'ERROR' || ['Error', 'Completed', 'New', 'Running', 'Starting', 'Pending'].indexOf(data.report_status) < 0) {
				this.is_error('warning');
				this.report_status_message('Error - no report data to display! Please ensure the query, table, or function has data!');
				return null;
			}

			if (data.report_status === 'Error') {
				this.is_error('danger');
				this.report_status_message(data.report_status);

				let response = await Grape.alerts.confirm({
					type: 'error',
					title: 'Error!',
					message: 'An unknown error occurred. Please ensure the query is valid or contact IT support. Do you want to open a log file?'
				});

				if (response)
					window.open('/api/bgworker/schedules/' + report_id + '/log', '_blank');
			}
			else if (data.report_status === 'Completed') {
				this.is_error(false);
				this.report_status_message('');
				this.table_name(data.result_table);

				let options = {
					schema: this.schema_name(),
					table: this.table_name()
				}

				let result = await Grape.fetches.getJSON('/api/record', options);
				if (result) {
					if (result.records.length > 0) {
						this.table_data(result.records);
						this.record_total(result.total);
					}
					else {
						Grape.alerts.alert({
							type: 'warning',
							title: 'No data!',
							message: 'There is no data to display for this report.'
						});
					}
				}
			}
			else {
				if (data.report_status === 'Running')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'NewTask')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'Pending')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'Starting')
					this.report_status_message(data.report_status);

				// Try again in 2000 milliseconds
				this.timer = setTimeout(
					() => {
						//this.get_report_results(this.report_id());
						this.get_report_results();
					},
					2000
				);
			}
		}
	}
}

export default {
	name: 'report-results-view',
	viewModel: ReportResultsViewModel,
	module_type: 'ko',
	template: template
};